import React from 'react';
import TelegramBotLists from './telegramBotLists';
import CreateTelegramBot from './createTelegramBot';

const styles = {
  container: {
    display: 'flex',
    flex: 1,
    gap: 20,
    flexDirection: 'column',
  },
};

function TelegramSetting(props) {
  return (
    <div style={styles.container}>
      <CreateTelegramBot {...props} />
      <TelegramBotLists {...props} />
    </div>
  );
}

export default TelegramSetting;
